import { IStore } from "./Models";

export interface IUserPreferences {
  modifiedDate: Date;
  defaultToRing: boolean;
  defaultToDriveTime: boolean;
  defaultSize: string /** can be single or multi-valued - i.e. "10", or "10,15,20" */;
  measurementTypeIsMile: boolean;
  measurementTypeIsKilometer: boolean;
  addToStudyAreaByDefault: boolean;
  autoColorByDefault: boolean;
  autoColorActualByDefault: boolean;
  defaultColor: string;
  defaultActualColor: string;
  defaultOpacity: number;
  defaultActualOpacity: number;
  activateActualDTByDefault: boolean;
  // border
  defaultBorderThicknessXThin: boolean;
  defaultBorderThicknessThin: boolean;
  defaultBorderThicknessMedium: boolean;
  defaultBorderThicknessThick: boolean;
  defaultActualBorderThicknessXThin: boolean;
  defaultActualBorderThicknessThin: boolean;
  defaultActualBorderThicknessMedium: boolean;
  defaultActualBorderThicknessThick: boolean;
  // territory
  defaultTerritoryDrawModeIsFreeDraw: boolean;
  defaultTerritoryDrawModeIsGeography: boolean;
  // collaborate
  collaborateLocationFilters: boolean;
  collaborateTerritories: boolean;
  collaboratePushpins: boolean;
  collaborateAOIThematics: boolean;
  collaborateViewReports: boolean;
  collaborateReportHistory: boolean;
  collaborateContactActivity: boolean;
  collaborateContacts: boolean;
  collaborateProspects: boolean;
  //
  printFileTypeOutputIsPdf: boolean;
  printFileTypeOutputIsPng: boolean;
  printDisplayActiveItemsLegend: boolean;
  defaultSite: IStore;
  defaultMatchViewIsGrid: boolean;
  defaultMatchViewIsList: boolean;
  defaultMatchAreaIsContacts: boolean;
  defaultMatchAreaIsMyActivity: boolean;
  defaultMatchAreaIsFiles: boolean;
  // CONTACT COLUMNS
  contactColumnNameDefaultVisible: boolean;
  contactColumnTitleDefaultVisible: boolean;
  contactColumnOfficePhoneDefaultVisible: boolean;
  contactColumnCellPhoneDefaultVisible: boolean;
  contactColumnEmailAddressDefaultVisible: boolean;
  contactColumnAddedByDefaultVisible: boolean;
  contactColumnAddressDefaultVisible: boolean;
  contactColumnLinkedinDefaultVisible: boolean;
  contactColumnRegionDefaultVisible: boolean;
  contactColumnTimeZoneDefaultVisible: boolean;
  contactColumnNotesDefaultVisible: boolean;
  // ACTIVITY COLUMNS
  activityColumnNameDefaultVisible: boolean;
  activityColumnDateCreatedDefaultVisible: boolean;
  activityColumnActivityResultDefaultVisible: boolean;
  activityColumnNextStepDefaultVisible: boolean;
  activityColumnNotesDefaultVisible: boolean;
  activityColumnCreatedByDefaultVisible: boolean;
  activityColumnDueDateDefaultVisible: boolean;
  activityColumnRatingDefaultVisible: boolean;
  // Search
  searchAreaDefaultInternet: boolean;
  searchAreaDefaultFiles: boolean;
  searchAreaDefaultLocations: boolean;
  searchAreaDefaultPushpins: boolean;
  searchAreaDefaultTerritories: boolean;
  // Login
  defaultLoginApp: string;
  // User Timeout Management
  sessionTimeoutLengthMinutes: number;
}
